<template>
  <div class="container">
    <div class="con-header">
      <div class="he-content">
        <div class="he-tit">选择丰派</div>
        <div class="he-tit">让自己领先一步</div>
        <div class="he-tip">10000+ 企业正在使用我们的产品降本增效</div>
        <div class="he-btn" @click="go">立即登录</div>
      </div>
    </div>
    <div class="con-posdownload">
      <div class="pos-content">
        <div class="pos-tit">下载丰派云POS收银应用</div>
        <div class="pos-tip">支持 iOS，Android，Windows，微信小程序版本</div>
        <div class="pos-mini-tip">
          <span class="word">开发者：东莞市丰派软件科技有限公司</span>
          <span class="line"></span>
          <span class="word">更新日期：2024-11-07</span>
          <span class="line"></span>
          <span class="blue-word">应用权限</span>
          <span class="line"></span>
          <span class="blue-word">隐私政策</span>
        </div>
        <div class="pos-down">
          <div class="down-item_s" @click="clickdownloadWin">
            <img
              class="appiconback"
              src="@/assets/newdownload/appback1.png"
              alt=""
            />
            <div class="pos-icon">
              <img
                class="appicon"
                src="@/assets/newdownload/appicon1.png"
                alt=""
              />
              <span class="appname">Windows</span>
              <img
                class="downicon"
                src="@/assets/newdownload/downicon.png"
                alt=""
              />
            </div>
            <!-- <div class="showdown">
              <div class="downselect">
                <div class="dsitem" @click="clickdownloadWin">
                  <img
                    class="dsimg"
                    src="@/assets/newdownload/posicon.png"
                    alt=""
                  />
                  <div class="dsname">零售版本</div>
                </div>
                <div class="dsitem" @click="clickdownloadai">
                  <img
                    class="dsimg"
                    src="@/assets/newdownload/posicon2.png"
                    alt=""
                  />
                  <div class="dsname">AI秤版本</div>
                </div>
              </div>
              <div
                class="downselectword"
                style="cursor: pointer"
                @click="openWinMask"
              >
                如何选择版本？
              </div>
            </div> -->
          </div>
          <div class="down-item_s" @click="clickdownloadAndroid">
            <img
              class="appiconback"
              src="@/assets/newdownload/appback2.png"
              alt=""
            />
            <div class="pos-icon">
              <img
                class="appicon"
                src="@/assets/newdownload/appicon2.png"
                alt=""
              />
              <span class="appname">Android</span>
              <img
                class="downicon"
                src="@/assets/newdownload/downicon.png"
                alt=""
              />
            </div>
            <!-- <div class="showdown">
              <div class="downselect">
                <div class="dsitem" @click="clickdownloadAndroid">
                  <img
                    class="dsimg"
                    src="@/assets/newdownload/posicon.png"
                    alt=""
                  />
                  <div class="dsname">零售版本</div>
                </div>
                <div class="dsitem" @click="clickdownloadAndroidAi">
                  <img
                    class="dsimg"
                    src="@/assets/newdownload/posicon2.png"
                    alt=""
                  />
                  <div class="dsname">AI秤版本</div>
                </div>
              </div>
              <div
                class="downselectword"
                style="cursor: pointer"
                @click="openAndMask"
              >
                如何选择版本？
              </div>
            </div> -->
          </div>
          <div class="down-item">
            <img
              class="appiconback"
              src="@/assets/newdownload/appback2.png"
              alt=""
            />
            <img
              class="downiconword"
              src="@/assets/newdownload/downiconword.png"
              alt=""
            />
            <div class="pos-icon">
              <img
                class="appicon"
                src="@/assets/newdownload/appicon3.png"
                alt=""
              />
              <span class="appname">收银手机后台</span>
              <img
                class="downicon code"
                src="@/assets/newdownload/downiconcode.png"
                alt=""
              />
            </div>
            <div class="showdown">
              <div class="sdcode">
                <img
                  class="showqrcode"
                  src="@/assets/newdownload/showqrcode.png"
                  alt=""
                />
              </div>
              <div class="downselectword code">扫码下载APP</div>
            </div>
          </div>
          <div class="down-item">
            <img
              class="appiconback"
              src="@/assets/newdownload/appback3.png"
              alt=""
            />
            <div class="pos-icon">
              <img
                class="appicon"
                src="@/assets/newdownload/appicon4.png"
                alt=""
              />
              <span class="appname">自助收银</span>
              <img
                class="downicon"
                src="@/assets/newdownload/downicon.png"
                alt=""
              />
            </div>
            <div class="showdown">
              <div class="downselect">
                <div class="dsitem" @click="$message.warning('暂未开放')">
                  <div class="dsname">Windows版本</div>
                </div>
                <div class="dsitem" @click="clickdownloadBySelf">
                  <div class="dsname">Android版本</div>
                </div>
              </div>
              <div class="downselectword">选择下载版本</div>
            </div>
          </div>
          <div class="down-item">
            <img
              class="appiconback"
              src="@/assets/newdownload/appback3.png"
              alt=""
            />
            <div class="pos-icon">
              <img
                class="appicon"
                src="@/assets/newdownload/appicon5.png"
                alt=""
              />
              <span class="appname">远程工具</span>
              <img
                class="downicon"
                src="@/assets/newdownload/downicon.png"
                alt=""
              />
            </div>
            <div class="showdown">
              <div class="downselect">
                <div class="dsitem" @click="clickdownloadWinRemote">
                  <div class="dsname">Windows版本</div>
                </div>
                <div class="dsitem" @click="clickdownloadWinVoice">
                  <div class="dsname">Android版本</div>
                </div>
              </div>
              <div class="downselectword">选择下载版本</div>
            </div>
          </div>
          <!-- <div class="down-item">
            <img
              class="appiconback"
              src="@/assets/newdownload/appback1.png"
              alt=""
            />
            <div class="pos-icon">
              <img
                class="appicon"
                src="@/assets/newdownload/appicon1.png"
                alt=""
              />
              <span class="appname">测试版本</span>
              <img
                class="downicon"
                src="@/assets/newdownload/downicon.png"
                alt=""
              />
            </div>
            <div class="showdown">
              <div class="downselect">
                <div class="dsitem" @click="clickdownloadAndroidNew">
                  <img
                    class="dsimg"
                    src="@/assets/newdownload/posicon.png"
                    alt=""
                  />
                  <div class="dsname">安卓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                </div>
                <div class="dsitem" @click="clickdownloadWinNew">
                  <img
                    class="dsimg"
                    src="@/assets/newdownload/posicon2.png"
                    alt=""
                  />
                  <div class="dsname">windows</div>
                </div>
              </div>
              <div
                class="downselectword"
                style="cursor: pointer"
                @click="openWinMask"
              >
                如何选择版本？
              </div>
            </div>
          </div> -->
        </div>
        <div class="pos-Applets">
          <div class="Applets-item">
            <img class="wxcode" src="@/assets/newdownload/wxcode.png" alt="" />
            <div class="ai-con">
              <div class="con-top">丰派云pos后台小程序</div>
              <div class="con-bottom">微信扫码进入</div>
            </div>
          </div>
          <div class="Applets-item">
            <img class="wxcode" src="@/assets/newdownload/twxcode.png" alt="" />
            <div class="ai-con">
              <div class="con-top">收银微商城体验小程序</div>
              <div class="con-bottom">微信扫码进入</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="con-lddownload">
      <div class="ld-content">
        <div class="ld-tit">下载订货平台应用</div>
        <div class="ld-tip">
          支持 iOS，Android，macOS，Windows，微信小程序等
        </div>
        <div class="ld-row">
          <img src="@/assets/newdownload/ldleft.png" alt="" class="ld-left" />
          <div class="ld-middle">
            <div class="ldm-tit">智慧零售应用</div>
            <div class="ldm-con">
              DIY商城、千店千面凸显门店/品牌特色，丰富的营销活动、会员人群管理、BI分析等。
            </div>
          </div>
          <div class="ld-right">
            <div class="ldr-con">
              <img
                class="downiconword"
                src="@/assets/newdownload/appback2.png"
                alt=""
              />
              <div class="pos-icon">
                <img
                  class="appicon"
                  src="@/assets/newdownload/appicon3.png"
                  alt=""
                />
                <span class="appname">零售商城小程序</span>
                <img
                  class="downicon code"
                  src="@/assets/newdownload/downiconcode.png"
                  alt=""
                />
              </div>
              <div class="showdown">
                <div class="sdcode">
                  <img
                    class="showqrcode"
                    src="@/assets/newdownload/showqrcode.png"
                    alt=""
                  />
                </div>
                <div class="downselectword">微信扫码体验</div>
              </div>
            </div>
            <div class="ldr-con">
              <img
                class="downiconword"
                src="@/assets/newdownload/appback2.png"
                alt=""
              />
              <div class="pos-icon">
                <img
                  class="appicon"
                  src="@/assets/newdownload/appicon3.png"
                  alt=""
                />
                <span class="appname">后台小程序</span>
                <img
                  class="downicon code"
                  src="@/assets/newdownload/downiconcode.png"
                  alt=""
                />
              </div>
              <div class="showdown">
                <div class="sdcode">
                  <img
                    class="showqrcode"
                    src="@/assets/newdownload/showqrcode.png"
                    alt=""
                  />
                </div>
                <div class="downselectword">微信扫码体验</div>
              </div>
            </div>
          </div>
        </div>
        <div class="ld-row top">
          <img src="@/assets/newdownload/ldleft.png" alt="" class="ld-left" />
          <div class="ld-middle">
            <div class="ldm-tit">订货平台应用</div>
            <div class="ldm-con">
              SaaS全链路全场景供应链解决方案，以“数字化落地+数字供应平台”数智技术驱动为底座。
            </div>
          </div>
          <div class="ld-right">
            <div class="ldr-con">
              <img
                class="downiconword"
                src="@/assets/newdownload/appback2.png"
                alt=""
              />
              <div class="pos-icon">
                <img
                  class="appicon"
                  src="@/assets/newdownload/appicon3.png"
                  alt=""
                />
                <span class="appname">订货商城小程序</span>
                <img
                  class="downicon code"
                  src="@/assets/newdownload/downiconcode.png"
                  alt=""
                />
              </div>
              <div class="showdown">
                <div class="sdcode">
                  <img
                    class="showqrcode"
                    src="@/assets/newdownload/ldsc.png"
                    alt=""
                  />
                </div>
                <div class="downselectword">微信扫码体验</div>
              </div>
            </div>
            <div class="ldr-con">
              <img
                class="downiconword"
                src="@/assets/newdownload/appback2.png"
                alt=""
              />
              <div class="pos-icon">
                <img
                  class="appicon"
                  src="@/assets/newdownload/appicon3.png"
                  alt=""
                />
                <span class="appname">管理后台APP</span>
                <img
                  class="downicon code"
                  src="@/assets/newdownload/downiconcode.png"
                  alt=""
                />
              </div>
              <div class="showdown">
                <div class="sdcode">
                  <img
                    class="showqrcode"
                    src="@/assets/newdownload/showqrcode.png"
                    alt=""
                  />
                </div>
                <div class="downselectword">扫码下载APP</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="helpMask" v-if="helpview" @click.stop="closeHelpModal">
      <div class="helpModal" @click.stop="">
        <div class="modal-close">
          <div></div>
          <img
            class="close"
            src="@/assets/newdownload/close.png"
            alt=""
            @click.stop="closeHelpModal"
          />
        </div>
        <div class="modal-top">
          <div class="modal-tit">选择适合您的收银应用版本</div>
          <div class="modal-btn">
            <div class="btn-down blue" @click.stop="downloadSaleVersion">
              下载零售版本
            </div>
            <div class="btn-down" @click.stop="downloadAiVersion">
              下载AI称重版本
            </div>
          </div>
        </div>
        <div class="modal-tip">
          <div class="mt-tit">如何选择安装版本？</div>
          <div class="mt-line">
            <span class="linenum">1</span
            >不需要使用称重功能的商超、便利店等，选择<span class="blue"
              >零售版本
            </span>
          </div>
          <div class="mt-line">
            <span class="linenum">2</span
            >需要使用称重功能的AI秤、电子秤等情况，选择<span class="blue"
              >AI称重版本
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "idownload",
  data() {
    return {
      helpview: false,
      visible: false,
      visible01: false,
      androidVisible: false,
      productMenu: 1,
      downloadcodeListOne: [
        {
          id: 1,
          tit: "收银系统手机后台",
          tip: "小程序扫码使用",
          img: require("@/assets/downloadcode1.png"),
          codeimg: require("@/assets/downloadicon1.png"),
          downloadUrl: "1",
        },
        {
          id: 2,
          tit: "收银系统手机后台",
          tip: "APP扫码下载",
          img: require("@/assets/downloadcode2.png"),
          codeimg: require("@/assets/downloadicon1.png"),
          downloadUrl: "",
        },
        {
          id: 3,
          tit: "收银系统客户端",
          tip: "Android版本下载",
          img: require("@/assets/downloadcode3.png"),
          codeimg: require("@/assets/downloadicon2.png"),
          downloadUrl:
            "https://data.fpsc.shop/fp_pos_android/fp_pos_android.apk",
        },
        {
          id: 4,
          tit: "收银系统客户端",
          tip: "Windows版本下载",
          img: require("@/assets/downloadcode4.png"),
          codeimg: require("@/assets/downloadicon2.png"),
          downloadUrl:
            "https://data.fpsc.shop/fp_pos_win/丰派云POS Setup 1.13.0.exe",
        },
      ],
      downloadcodeListtwo: [
        {
          id: 5,
          tit: "丰派移动管家",
          tip: "小程序扫码使用",
          img: require("@/assets/downloadcode5.png"),
          codeimg: require("@/assets/downloadicon1.png"),
          downloadUrl: "1",
        },
        {
          id: 6,
          tit: "丰派智慧导购",
          tip: "小程序扫码使用",
          img: require("@/assets/downloadcode6.png"),
          codeimg: require("@/assets/downloadicon1.png"),
          downloadUrl: "1",
        },
        {
          id: 7,
          tit: "丰派零售商城",
          tip: "小程序扫码使用",
          img: require("@/assets/downloadcode7.png"),
          codeimg: require("@/assets/downloadicon1.png"),
          downloadUrl: "1",
        },
      ],
      downloadcodeListthree: [
        {
          id: 8,
          tit: "丰派订货商城",
          tip: "小程序扫码使用",
          img: require("@/assets/downloadcode8.png"),
          codeimg: require("@/assets/downloadicon1.png"),
          downloadUrl: "1",
        },
        {
          id: 9,
          tit: "收银系统客户端",
          tip: "APP扫码下载",
          img: require("@/assets/downloadcode9.png"),
          codeimg: require("@/assets/downloadicon2.png"),
          downloadUrl: "",
        },
        {
          id: 10,
          tit: "收银系统手机后台",
          tip: "APP扫码下载",
          img: require("@/assets/downloadcode10.png"),
          codeimg: require("@/assets/downloadicon1.png"),
          downloadUrl: "",
        },
        {
          id: 11,
          tit: "手机后台",
          tip: "ios版本下载",
          img: require("@/assets/downloadcode11.png"),
          codeimg: require("@/assets/downloadicon2.png"),
          downloadUrl: "",
        },
      ],
      winurl: require("@/assets/win1.png"),
      winVoiceUrl: require("@/assets/winRemote.png"),
      wintext: "Windows客户端",
      Androidurl: require("@/assets/win3.png"),
      Androidtext: "收银Android客户端",
      wxurl: require("@/assets/win7.png"),
      wxtext: "收银后台小程序",
      pcurl: require("@/assets/win5.png"),
      pctext: "收银后台APP",
      pcVoiceText: "远程工具 ",
    };
  },
  // mounted() {
  //   try {
  //     PAGInit().then(async (PAG) => {
  //       const pagUrl = "https://img.fp1123.com/group1/M00/00/09/CgAFBmIeyG-ANH1pAADMZruJMdA118.pag";
  //       const fileBlob = await fetch(pagUrl).then((response) => {
  //         console.log(response);
  //         return response.blob();
  //       });
  //       // var fileBlob = pagUrl.blob();
  //       console.log(fileBlob);
  //       const file = new File(
  //         [fileBlob],
  //         pagUrl.replace(/(.*\/)*([^.]+)/i, "$2")
  //       );
  //       const pagFile = await PAG.PAGFile.load(file);
  //       document.getElementById("pag").width = pagFile.width();
  //       document.getElementById("pag").height = pagFile.height();
  //       const pagView = await PAG.PAGView.init(pagFile, "#pag");
  //       pagView.setRepeatCount(0);
  //       await pagView.play();
  //     });
  //   } catch (error) {
  //     console.log("err", error);
  //   }
  // },

  activated() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
  methods: {
    downloadAPP() {
      let elink = document.createElement("a");
      elink.download = "收银手机后台";
      elink.style.display = "none";
      elink.href =
        "https://www.ld8848.cn/fp_pos_phone_admin/fp_pos_phone_admin.apk";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    go() {
      location.href = "https://www.fp1123.com/fpPos/#/login";
    },
    onmouseoverWin1() {
      this.winurl = require("@/assets/win2.png");
      this.wintext = "点击下载";
    },
    mouseleaveWin1() {
      this.winurl = require("@/assets/win1.png");
      this.wintext = "Windows客户端";
    },
    clickdownloadWin() {
      let elink = document.createElement("a");
      elink.download = "Windows版本下载";
      elink.style.display = "none";
      elink.href = "https://data.fpsc.shop/fp_pos_win/丰派云POS Setup 1.13.0.exe";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    clickdownloadWinNew() {
      let elink = document.createElement("a");
      elink.download = "Windows测试版本下载";
      elink.style.display = "none";
      elink.href =
        "https://www.ld8848.cn/fp_pos_win/丰派云POS Setup 1.6.0_latest.exe";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    clickdownloadBySelf() {
      let elink = document.createElement("a");
      elink.download = "自助收银版本下载";
      elink.style.display = "none";
      elink.href = "https://www.ld8848.cn/fp_pos_auto/fp_pos_auto.apk";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    clickdownloadai() {
      let elink = document.createElement("a");
      elink.download = "Windows版本下载ai";
      elink.style.display = "none";
      elink.href =
        "https://www.ld8848.cn/fp_pos_win_ai/丰派云POS_AI Setup 1.5.0.exe";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    clickdownloadWinVoice() {
      let elink = document.createElement("a");
      elink.download = "远程工具 ";
      elink.style.display = "none";
      elink.href = "https://www.ld8848.cn/fp_help/fp_help.apk";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    clickdownloadWinRemote() {
      let elink = document.createElement("a");
      elink.download = "Windows远程工具 ";
      elink.style.display = "none";
      elink.href = "https://www.ld8848.cn/fp_help/fprjwin.exe";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    onmouseoverAndroid2() {
      this.Androidurl = require("@/assets/win4.png");
      this.Androidtext = "点击下载";
    },
    mouseleaveAndroid2() {
      this.Androidurl = require("@/assets/win3.png");
      this.Androidtext = "收银Android客户端";
    },
    clickdownloadAndroid() {
      let elink = document.createElement("a");
      elink.download = "Android版本下载";
      elink.style.display = "none";
      elink.href = "https://data.fpsc.shop/fp_pos_android/fp_pos_android.apk";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    clickdownloadAndroidNew() {
      let elink = document.createElement("a");
      elink.download = "Android测试版本下载";
      elink.style.display = "none";
      elink.href =
        "https://data.fpsc.shop/fp_pos_android/fp_pos_android_latest.apk";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    clickdownloadAndroidAi() {
      let elink = document.createElement("a");
      elink.download = "Android Ai版本下载";
      elink.style.display = "none";
      elink.href =
        "https://www.ld8848.cn/fp_pos_android_ai/fp_pos_android_ai.apk";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    onmouseoverWx2() {
      this.wxurl = require("@/assets/win8.png");
      this.wxtext = "微信扫描使用";
    },
    mouseleaveWx2() {
      this.wxurl = require("@/assets/win7.png");
      this.wxtext = "收银后台小程序";
    },
    onmouseoverPc2() {
      this.pcurl = require("@/assets/win6.png");
      this.pctext = "扫码下载";
    },
    onmouseoverPc3() {
      this.winVoiceUrl = require("@/assets/xzyy.png");
      this.pcVoiceText = "点击下载";
    },
    onmouseoverPc4() {
      this.winRemoteUrl = require("@/assets/xzyy.png");
      this.winRemoteText = "点击下载";
    },
    mouseleavePc3() {
      this.winVoiceUrl = require("@/assets/yyb.png");
      this.pcVoiceText = "远程工具 ";
    },
    mouseleavePc4() {
      this.winRemoteUrl = require("@/assets/winRemote.png");
      this.winRemoteText = "Windows远程工具 ";
    },
    mouseleavePc2() {
      this.pcurl = require("@/assets/win5.png");
      this.pctext = "收银手机后台APP";
    },
    clickdownloadPc() {
      // this.$message.warning("暂无下载地址");
    },

    clickdownload(result) {
      if (result.downloadUrl && result.downloadUrl !== "1") {
        // this.$message.warning("下载地址");
        // window.open(result.downloadUrl);
        let elink = document.createElement("a");
        elink.download = result.tit;
        elink.style.display = "none";
        elink.href = result.downloadUrl;
        elink.target = "_self";
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      } else if (result.downloadUrl == "1") {
        return;
      } else {
        this.$message.warning("暂无下载地址");
      }
    },
    // 版本选择提示
    closeHelpModal() {
      this.helpview = false;
    },
    openWinMask() {
      this.helpview = true;
      this.versionType = 1;
    },
    openAndMask() {
      this.helpview = true;
      this.versionType = 2;
    },
    // 下载零售版本
    downloadSaleVersion() {
      if (this.versionType == 1) {
        this.clickdownloadWin();
      } else {
        this.clickdownloadAndroid();
      }
    },
    // 下载AI称重版本
    downloadAiVersion() {
      if (this.versionType == 1) {
        this.clickdownloadai();
      } else {
        this.clickdownloadAndroidAi();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  position: relative;
  top: 64px;
  width: 100%;
  min-width: 1420px;
  background: #ffffff;
}
.mixin-word() {
  font-family: "Noto Sans SC";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
}
.con-header {
  width: 100%;
  height: 560px;
  position: relative;
  background: #5c8cff;
  background: url("~@/assets/newdownload/fpdown1.png");
  .he-content {
    width: 1200px;
    position: absolute;
    top: 21%;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }
  .he-tit {
    .mixin-word;
    font-weight: 500;
    font-size: 64px;
    line-height: 88px;
    color: #292929;
  }
  .he-tip {
    margin-top: 20px;
    .mixin-word;
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    color: #637392;
  }
  .he-btn {
    cursor: pointer;
    margin-top: 50px;
    font-size: 20px;
    text-align: center;
    color: #ffffff;
    width: 164px;
    height: 54px;
    line-height: 54px;
    background: #336fff;
    box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
    border-radius: 6px;
    &:hover {
      background: #5c8cff;
      box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
    }
  }
}
.con-posdownload {
  width: 100%;
  height: 740px;
  background: #fafcff;
  padding-top: 80px;
  padding-bottom: 40px;
  .pos-content {
    width: 1200px;
    margin: 0 auto;
  }
  .pos-tit {
    .mixin-word;
    font-size: 40px;
    line-height: 48px;
    text-align: center;
    color: #1f2329;
  }
  .pos-tip {
    margin-top: 16px;
    .mixin-word;
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    text-align: center;
    color: #51565d;
  }
  .pos-mini-tip {
    margin-top: 16px;
    text-align: center;
    .word {
      .mixin-word;
      font-size: 13px;
      line-height: 22px;
      color: #8f959e;
    }
    .blue-word {
      cursor: pointer;
      .mixin-word;
      font-size: 13px;
      line-height: 22px;
      color: #3370ff;
    }
    .line {
      display: inline-block;
      width: 1px;
      height: 12px;
      background: #dee0e3;
      margin: 0 26px;
    }
  }
  .pos-down {
    margin-top: 40px;
    display: flex;
    align-items: center;
    .appiconback {
        width: 180px;
      }
      .downiconword {
        height: 24px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 20;
      }
      .pos-icon {
        width: 180px;
        height: 180px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 5;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .appname {
          margin-top: 10px;
          .mixin-word;
          font-weight: 500;
          font-size: 22px;
          line-height: 33px;
          text-align: center;
          color: #ffffff;
        }
        .appicon {
          width: 100px;
          height: 100px;
        }
        .downicon {
          width: 36px;
          height: 36px;
          cursor: pointer;
          position: absolute;
          top: 10px;
          right: 10px;
          &.code {
            width: 64px;
            height: 64px;
            top: 0;
            right: 0;
          }
        }
      }
      .showdown {
        display: none;
        width: 180px;
        height: 180px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        // display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .downselect {
          padding: 12px;
          width: 140px;
          height: 124px;
          background: rgba(255, 255, 255, 0.9);
          box-shadow: 0px 18px 43px rgba(74, 130, 183, 0.15);
          border-radius: 12px;
          .dsitem {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0px 12px;
            width: 120px;
            height: 40px;
            cursor: pointer;
            .dsimg {
              width: 24.56px;
              height: 24px;
              margin-right: 16px;
            }
            .dsname {
              .mixin-word;
              font-size: 13px;
              line-height: 26px;
              color: #292929;
            }
            &:hover {
              background: #ffffff;
              .dsname {
                color: #336fff;
              }
            }
          }
        }
        .sdcode {
          width: 140px;
          height: 140px;
          background: rgba(255, 255, 255, 0.9);
          box-shadow: 0px 18px 43px rgba(74, 130, 183, 0.15);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          .showqrcode {
            width: 100px;
            height: 100px;
          }
        }
        .downselectword {
          margin-top: 12px;
          .mixin-word;
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
          color: #ffffff;
          &.code {
            margin-top: 4px;
          }
        }
      }
    .down-item_s {
      width: 220px;
      height: 220px;
      overflow: hidden;
      position: relative;
      cursor: pointer
    }
    .down-item_s + .down-item_s {
      margin-left: 24px;
    }
    .down-item {
      width: 220px;
      height: 220px;
      overflow: hidden;
      position: relative;
      &:hover .showdown {
        display: flex;
      }
      &:hover .pos-icon {
        display: none;
      }

    }
    .down-item + .down-item {
      margin-left: 24px;
    }
  }
  .pos-Applets {
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    .Applets-item {
      width: 420px;
      height: 150px;
      padding: 0px 24px;
      filter: drop-shadow(0px 10px 30px #dbebfc);
      background: url("~@/assets/newdownload/wxback.png");
      border-radius: 20px;
      display: flex;
      align-items: center;
      .wxcode {
        width: 132px;
        height: 132px;
        margin-right: 12px;
      }
      .ai-con {
        .con-top {
          .mixin-word;
          font-size: 22px;
          line-height: 30px;
          color: #292929;
        }
        .con-bottom {
          margin-top: 8px;
          .mixin-word;
          font-size: 16px;
          line-height: 24px;
          color: #336fff;
        }
      }
    }
    .Applets-item + .Applets-item {
      margin-left: 24px;
    }
  }
}
.con-lddownload {
  width: 100%;
  height: 772px;
  background: #fafafc;
  padding: 40px 0;
  .ld-content {
    width: 1200px;
    margin: 0 auto;
  }
  .ld-tit {
    .mixin-word;
    font-size: 40px;
    line-height: 48px;
    text-align: center;
    color: #1f2329;
  }
  .ld-tip {
    margin-top: 16px;
    font-size: 18px;
    line-height: 28px;
    text-align: center;
    color: #51565d;
  }
  .ld-row {
    display: flex;
    align-items: center;
    height: 300px;
    &.top {
      border-top: 1px solid #d7dde0;
    }
    .ld-left {
      width: 268px;
      height: 185px;
    }
    .ld-middle {
      margin-left: 24px;
      margin-right: 24px;
      .ldm-tit {
        .mixin-word;
        font-weight: 500;
        font-size: 24px;
        line-height: 32px;
        color: #262a47;
      }
      .ldm-con {
        margin-top: 12px;
        .mixin-word;
        color: #6c727b;
      }
    }
    .ld-right {
      display: flex;
      align-items: center;
      .ldr-con {
        width: 220px;
        height: 220px;
        position: relative;
        // &:hover .showdown {
        //   display: flex;
        // }
        // &:hover .pos-icon {
        //   display: none;
        // }
      }
      .ldr-con + .ldr-con {
        margin-left: 24px;
      }
      .pos-icon {
        width: 220px;
        height: 220px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 5;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .appname {
          margin-top: 10px;
          .mixin-word;
          font-weight: 500;
          font-size: 22px;
          line-height: 33px;
          text-align: center;
          color: #ffffff;
        }
        .appicon {
          width: 100px;
          height: 100px;
        }
        .downicon {
          width: 36px;
          height: 36px;
          cursor: pointer;
          position: absolute;
          top: 10px;
          right: 10px;
          &.code {
            width: 64px;
            height: 64px;
            top: 0;
            right: 0;
          }
        }
      }
      .showdown {
        display: none;
        width: 140px;
        height: 220px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        // display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .sdcode {
          width: 160px;
          height: 160px;
          background: rgba(255, 255, 255, 0.9);
          box-shadow: 0px 18px 43px rgba(74, 130, 183, 0.15);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          .showqrcode {
            width: 136px;
            height: 136px;
          }
        }
        .downselectword {
          margin-top: 4px;
          .mixin-word;
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
          color: #ffffff;
        }
      }
    }
  }
}
.helpMask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  // width: 100%;
  // height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 30;

  .helpModal {
    width: 640px;
    height: 376px;
    background: #ffffff;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    .modal-close {
      padding: 12px;
      width: 640px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .close {
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
    }
    .modal-top {
      width: 560px;
      height: 158px;
      align-self: center;
      border-bottom: 1px solid #d7dde0;
    }
    .modal-tit {
      .mixin-word;
      font-size: 32px;
      line-height: 40px;
      text-align: center;
      color: #000000;
    }
    .modal-btn {
      margin-top: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      .btn-down {
        width: 214px;
        height: 54px;
        padding: 0px 24px;
        background: #ffffff;
        border: 1px solid #d7dde0;
        border-radius: 4px;
        .mixin-word;
        font-size: 20px;
        line-height: 54px;
        color: #292929;
        cursor: pointer;
        text-align: center;
        &.blue {
          background: #336fff;
          color: #ffffff;
          border: none;
        }
      }
      .btn-down + .btn-down {
        margin-left: 12px;
      }
    }
    .modal-tip {
      margin-top: 20px;
      width: 560px;
      height: 150px;
      align-self: center;
      .mt-tit {
        .mixin-word;
        font-size: 20px;
        line-height: 30px;
        color: #000000;
      }
      .mt-line {
        margin-top: 16px;
        .mixin-word;
        font-size: 14px;
        line-height: 24px;
        color: #292929;
        .linenum {
          display: inline-block;
          width: 20px;
          height: 20px;
          background: #336fff;
          border-radius: 50%;
          .mixin-word;
          color: #ffffff;
          line-height: 20px;
          text-align: center;
          margin-right: 8px;
        }
        .blue {
          color: #336fff;
          // cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/download.vue